export enum Roles {

    LandManager = 1,
    TenureApplicant = 2,
    KioskAdministrator = 3

}
